"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelButtonText = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.LabelButtonText = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  flex-grow: 1;\n  text-align: center;\n  font-size: medium;\n  text-overflow: clip;\n"], ["\n  flex-grow: 1;\n  text-align: center;\n  font-size: medium;\n  text-overflow: clip;\n"])));
var templateObject_1;
